export enum PurchaseResultParam {
  TOKEN_WS = 'token_ws',
  TBK_TOKEN = 'TBK_TOKEN',
  TBK_ORDEN_COMPRA = 'TBK_ORDEN_COMPRA',
  TBK_ID_SESION = 'TBK_ID_SESION',
  OC = 'oc',
  RESULT = 'r',
  PAYMENT_ACCEPTED = 'PAYMENT_ACCEPTED',
  PAYMENT_NOT_ACCEPTED = 'PAYMENT_NOT_ACCEPTED',
}
export const PaymentResponseCode = {
  TRANSACTION_APPROVED: 0,
  TRANSACTION_DATA_ENTRY_ERROR: -1,
  ERROR_PROCCESSING_TRANSACTION: -2,
  ERROR_IN_TRANSACTION: -3,
  REJECTED_BY_SENDER: -4,
  POSIBLE_FRAUD: -5,
};

export enum DeliveryStatus {
  PENDING = 'PENDING',
  DELIVERED = 'DELIVERED',
  NO_APPLY = 'NO_APPLY',
}

export enum OrderStatus {
  OPEN = 'OPEN',
  PROCESED = 'PROCESED',
  CLOSE = 'CLOSE',
}

export const PaymentMethodSlug = {
  MERCADO_PAGO: 'mercadopago',
  WEB_PAY: 'webpay',
  PAGO_FLASH: 'pagoflash',
};

export enum DiscountType {
  FIXED = 'FIXED',
  PERCENTAGE = 'PERCENTAGE',
}

export enum CouponAction {
  VERIFY = 'VERIFY',
  TOGGLE = 'TOGGLE',
}

export enum DeliveryType {
  DELIVERY = 'delivery',
  PICKUP = 'pickup',
}

export enum WebPayStatus {
  COMPLETED = 'COMPLETED',
  ABORTED = 'ABORTED',
  TIMEOUT = 'TIMEOUT',
  INITIAL = 'INITIAL',
}

export enum PaymentStatus {
  SUCCESS = 'SUCCESS',
  FAILED = 'FAILED',
  PENDING = 'PENDING',
}
